.th {
  position: relative;
  font-weight: 400;
  text-align: left;
  white-space: nowrap;
}

.th svg {
  fill: currentcolor;
  width: 0.8rem;
}

.check {
  padding: 0 7px;
}

.content {
  padding-left: 7px;
  display: flex;
  align-items: center;
}

.check,
.content {
  line-height: 30px;
  cursor: default;
}

.text {
  color: var(--main-text-soft);
  font-size: 0.75rem;
}

.text:hover {
  text-decoration: underline;
}

.check:hover,
.content:hover {
  background-color: var(--hover-light);
}

.menu-container {
  padding-left: 5px;
  margin-left: auto;
}

.content .menu {
  visibility: hidden;
}

.content:hover .menu {
  visibility: visible;
}
